<template>
  <div>
    <div class="div-row" v-for="(value, counter) in values" :key="counter">
      <form-fill-field
        :autosave-values="autosaveValues"
        :checklist="checklist"
        :value="value"
        :field-id="counter"
        :modelstate="modelstate"
        :token="token"
      >
      </form-fill-field>

      <form-fill-fields
        :autosave-values="autosaveValues"
        :checklist="checklist"
        :values="getAditionalFields(value)"
        :modelstate="modelstate"
        :token="token"
      >
      </form-fill-fields>
    </div>
    <!-- <div>{{ modelstate }}</div> -->
    <!-- <div>{{ checklist }}</div> -->
    <!-- <pre class="language-json"><code>{{ values  }}</code></pre> -->
    <!-- {{ values }} -->
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);

export default {
  name: "Fill",
  components: {
    FormFillField: () =>
      import("@/components_rms/checklist/form/FormFillField.vue"),
    FormFillFields: () =>
      import("@/components_rms/checklist/form/FormFillFields.vue")
  },
  props: {
    values: Array,
    autosaveValues: Array,
    checklist: Object,
    modelstate: Object,
    token: {
      description: "Token de acesso",
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      inputChangeDebounce: 5000,
      optionsBoolean: [
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" }
      ]
    };
  },
  methods: {
    getAditionalFields(field) {
      let fields = [];
      if (field.value != null) {
        if (field.options != null) {
          for (let opt of field.options) {
            if (opt.value == field.value) {
              if (opt.additional != null) {
                for (let aditionalField of opt.additional) {
                  fields.push(aditionalField);
                }
              }
            }
          }
        }
      }
      return fields;
    },
    handleFileUpload(event, object) {
      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          object.attachment = reader.result;
          this.onDataChange(object);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    updateImageSrc(originObject, newValue) {
      originObject.attachment = newValue;
      this.onDataChange(originObject);
      this.$forceUpdate();
    },
    async onDataChange(item) {
      if (this.checklist.id == 0 || this.checklist.draft) {
        if (this.autosaveValues.indexOf(item) < 0) {
          this.autosaveValues.push(item);
        }
      }
    }
  }
};
</script>
